<div fxLayout="column">
  <app-page-header
    (tabsChangeEvent)="changeTabs($event)"
    [selectedTab]="getInitialTab()"
    [description]="pageHeader.get(paymentMethodMode)!.description"
    [isTabbed]="true"
    [section]="pageHeader.get(paymentMethodMode)!.section"
    [tabs]="tabs"
    [title]="pageHeader.get(paymentMethodMode)!.title"></app-page-header>

<!--  Main filter which needs to be selected before refresh enabled and tables will show-->
  <div class="full-screen-height-page-banner page-content page-padding" fxLayout="column">
<!--    <div class="body-1-primary">{{ importMessage }}</div>-->

    <div fxFlexAlign="end">
      <app-info-panel [type]="PanelType.INFO" *ngIf="!importMessage && !errorsToFix"
                      [message]="[refreshMessage]"></app-info-panel>
      <app-info-panel [type]="PanelType.INFO" *ngIf="importMessage"
                      [message]="[importMessage]"></app-info-panel>
      <app-info-panel [type]="PanelType.WARN" *ngIf="errorsToFix && !importMessage"
                      [message]="['Found errors in the trading report which may lead to incorrect data. Please checked the unlinked sales to fix these issues.']"></app-info-panel>
    </div>

    <div class="info-card p-4" fxLayout="column" fxLayoutAlign="start start" fxFlexOffset="15px">
      <div class="full-width" fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always">
          <mat-label>Share Point-of-sale Type</mat-label>
          <mat-select class="custom-select-field-value" placeholder="Select" [formControl]="paymentConfigType">
            <mat-option class="custom-select-field-option" value="OFFERING">OFFERING</mat-option>
            <mat-option class="custom-select-field-option" value="SHARED">SHARED</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always">
          <mat-label>Share Point-of-sale Account</mat-label>
          <mat-select class="custom-select-field-value" placeholder="Select" [formControl]="selectedConfig">
            <mat-option class="custom-select-field-option" *ngFor="let config of selectablePaymentConfigs" [value]="config.uuid">{{getDisplayName(config)}}</mat-option>
          </mat-select>
        </mat-form-field>

        <app-custom-date-filter [customDateRangePresets]="dateFilters"
                                (dateRange)="getDateRange($event)" [initialPreset]="'1'"></app-custom-date-filter>

        <div fxLayout="row" fxLayoutGap="10px">
          <button class="button-primary" mat-flat-button
                  (click)="importTransactionsForConfig()"
                  [disabled]="configFiltersNotSet || !canUserImportData || !!(loader.loading$ | async)">
            <div class="button-text">Refresh</div>
          </button>

          <button class="button-primary" mat-flat-button
                  (click)="importProductsAndTransactionsForConfig()"
                  [disabled]="configFiltersNotSet || !errorsToFix || !canUserImportData || !!(loader.loading$ | async)">
            <div class="button-text">Fix Errors</div>
          </button>
        </div>
      </div>

    </div>

<!--  Linked sales will show total and retailer reports-->
    <div *ngIf="activeTab =='linked_sales' && showTables" fxLayout="column">

      <app-total-trading-report #totalReport *ngIf="totalTradingReport"
                                [totalTradingReport]="totalTradingReport"></app-total-trading-report>

      <app-retailer-trading-report #retailerReport *ngIf="retailerTradingReport"
                                   [reportName]="paymentMethodMode == 'ALL' ? 'Daily Trading Report' : 'Cash Trading Report'"
                                   [retailerReport]="retailerTradingReport"></app-retailer-trading-report>
    </div>

<!--  unlinked sales will show error reports-->
    <div *ngIf="activeTab =='unlinked_sales' && showTables">
      <app-error-trading-report *ngIf="totalTradingReport"
                                [paymentMethodType]="paymentConfigType.value"
                                [totalTradingReport]="totalTradingReport"></app-error-trading-report>
    </div>

  </div>
</div>
